import { createContext } from 'react';
import PropTypes from 'prop-types';

export const ContemporaryLandingContext = createContext({});

export function ContemporaryLandingContextProvider({
    children,
    isDesktop,
    isMobile,
    isTablet,
    userType,
}) {
    return (
        <ContemporaryLandingContext.Provider
            value={{
                isMobile,
                isTablet,
                isDesktop,
                userType,
            }}
        >
            {children}
        </ContemporaryLandingContext.Provider>
    );
}

ContemporaryLandingContextProvider.propTypes = {
    children: PropTypes.node,
    isMobile: PropTypes.bool.isRequired,
    isTablet: PropTypes.bool.isRequired,
    isDesktop: PropTypes.bool.isRequired,
    userType: PropTypes.string.isRequired,
};
